import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface KambiState {
  isVisible: boolean
  isLoggedIn: boolean
  isBetslipMaximized: boolean
  logoutToken: string | null
  isLoginPending: boolean
  isKambiRendered: boolean
  playerSessionId?: string
  isBrowserSupported: boolean
  isInSignUp: boolean
  isReloadPending: boolean
  activeJurisdiction: 'rwwawa' | 'rwwasa' | null
}

export const initialState: KambiState = {
  isVisible: false,
  isLoggedIn: false,
  isBetslipMaximized: false,
  logoutToken: null,
  isLoginPending: false,
  isKambiRendered: false,
  isBrowserSupported: true,
  isInSignUp: false,
  isReloadPending: false,
  activeJurisdiction: null,
}

const kambiSlice = createSlice({
  name: 'kambi',
  initialState,
  reducers: {
    setKambiVisibility(state, action: PayloadAction<boolean>) {
      state.isVisible = action.payload
    },

    setIsKambiLoginPending(state, action: PayloadAction<boolean>) {
      state.isLoginPending = action.payload
    },

    loggedInKambiPlayer(state, action: PayloadAction<string>) {
      state.isLoggedIn = true
      state.logoutToken = action.payload
      state.isLoginPending = false
    },

    loggedOutKambiPlayer(state) {
      state.isLoggedIn = false
      state.logoutToken = null
      state.isLoginPending = false
    },

    updateBetslipMaximized(state, action: PayloadAction<boolean>) {
      state.isBetslipMaximized = action.payload
    },

    updateUserData(state, action: PayloadAction<string>) {
      state.playerSessionId = action.payload
    },

    removeKambiSpinner(state) {
      state.isKambiRendered = true
    },

    setUnsupportedBrowser(state) {
      state.isBrowserSupported = false
      state.isKambiRendered = true
    },

    setIsInSignUp(state, action: PayloadAction<boolean>) {
      state.isInSignUp = action.payload
    },

    setIsReloadPending(state, action: PayloadAction<boolean>) {
      state.isReloadPending = action.payload
    },

    setActiveKambiJurisdiction(state, action: PayloadAction<'rwwawa' | 'rwwasa'>) {
      state.activeJurisdiction = action.payload
    },
  },
})

export const {
  setKambiVisibility,
  setIsKambiLoginPending,
  loggedInKambiPlayer,
  loggedOutKambiPlayer,
  updateBetslipMaximized,
  updateUserData,
  removeKambiSpinner,
  setUnsupportedBrowser,
  setIsInSignUp,
  setIsReloadPending,
  setActiveKambiJurisdiction,
} = kambiSlice.actions

export default kambiSlice.reducer
